// Brand images are served by the environment's asset host, chosen at build time (see .env and the deploy workflow).
export const ASSETS_BASE_URL = `${import.meta.env.VITE_ASSETS_BASE_URL}/assets`;

const assetUrl = (fileName: string) => `${ASSETS_BASE_URL}/${fileName}`;

export const ASSETS = {
  LOGO: assetUrl('roade_logo.png'),
  HOME_BOTTOM: assetUrl('home-page-default.png'),
  HERO: assetUrl('main-image.png'),
  PIN: assetUrl('location-pin.png'),
  LEFT_ARROW: assetUrl('type-left.png'),
  RIGHT_ARROW: assetUrl('type-right.png'),
  BACK_ARROW: assetUrl('arrow-left.png'),
  REPORT: assetUrl('report.svg'),
  FACEBOOK: assetUrl('Fb.svg'),
  INSTAGRAM: assetUrl('Ig.svg'),
  TIKTOK: assetUrl('tik_tok.png'),
  LOGIN_IMAGE: assetUrl('login-image.png'),
  REGISTER_IMAGE: assetUrl('register-image.png'),
  ANPC_SAL: assetUrl('anpc_sal.svg'),
  SEND: assetUrl('Send.png'),
} as const;
